<template>
  <v-content>
    <v-container>
      <v-layout row wrap align-center justify-center>
        <v-flex xs12 class="mt-5 mb-5">
          <v-layout row wrap justify-center>
            <v-flex class="d-flex justify-center">
              <v-img :src="logo"></v-img>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm8 md6 xl4>
          <router-view/>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'FrontLayout',

  data: () => ({
    logo: require('@/assets/logo.png')
  })
}
</script>

<style scoped>
  .v-image {
    max-width: 120px;
  }
</style>
